import * as React from "react";
function SvgSoundcloud(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        fill="#fff"
        d="M12.92 10h1.32v11.88h-1.32zm-2.64 4h1.32v7.92h-1.32zm-2.64-1.36H9v9.24H7.64zM5 16.6h1.32v5.28H5zM23.19 14a4 4 0 014.34 4 4 4 0 01-4 4h-8V10.31l.5-.12a5.67 5.67 0 011.51-.19 6 6 0 015.65 4z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSoundcloud);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
